import './App.css'

import { AuthProvider } from './auth/AuthProvider'
import { routes } from './router/config'
import { Router } from './router/Router'

export const App = () => (
  <AuthProvider>
    <Router routes={routes} />
  </AuthProvider>
)
